import { Middleware } from "@reduxjs/toolkit";

import { mirrorTokensToV2 } from "../adopt-v2-session";
import { setAuthInfo, updateTokens } from "./auth-reducer";

/**
 * Keeps the new family app's copy of the session alive across this app's
 * token rotations.
 *
 * Every path that changes this app's pair ends in one of these two actions:
 * SessionGate's response interceptor, the session validation query and the
 * cut-over gate's evaluate call all dispatch updateTokens, and a login or an
 * adoption dispatches setAuthInfo. Hooking the actions rather than the call
 * sites means a rotation added later cannot forget to tell the other app.
 *
 * Reads the slice after the reducer has run, so the pair and the user id are
 * the ones this app now holds. The write itself only happens on the web and
 * only into a session that belongs to the same user (adopt-v2-session.web.ts);
 * on native mirrorTokensToV2 does nothing.
 */
export const v2SessionMirror: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  if (updateTokens.match(action) || setAuthInfo.match(action)) {
    const { userId, accessToken, refreshToken } = store.getState().auth ?? {};

    if (userId && accessToken && refreshToken) {
      mirrorTokensToV2({ userId, accessToken, refreshToken });
    }
  }

  return result;
};
